import _extends from "@babel/runtime/helpers/extends";
import { TooltipProvider as RadixTooltipProvider } from "@radix-ui/react-tooltip";
import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
function TooltipProvider(props) {
  return /*#__PURE__*/_jsx(RadixTooltipProvider, _extends({
    delayDuration: 350
  }, props));
}
export default TooltipProvider;